<app-inactivity-timer></app-inactivity-timer>
<router-outlet></router-outlet>
